import { initializeApp } from 'firebase/app';
import * as firebase from 'firebase/app';
import 'firebase/storage';
import 'firebase/firestore';

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyDurxi2Axa3UAMIdl8CssqIn_Cy73UsiEM",
    authDomain: "ninja-firegram-fb2dd.firebaseapp.com",
    projectId: "ninja-firegram-fb2dd",
    storageBucket: "ninja-firegram-fb2dd.appspot.com",
    messagingSenderId: "552220587776",
    appId: "1:552220587776:web:8f295b0473212cb963e5e5"
  };
  
  // Initialize Firebase
  const app = initializeApp(firebaseConfig);

  const projectStorage = firebase.storage();
  const projectFirestore = firebase.firestore();
  const timestamp = firebase.firestore.FieldValue.serverTimestamp;

  export { projectStorage, projectFirestore, timestamp };